"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CardActionArea.default;
  }
});

var _CardActionArea = _interopRequireDefault(require("./CardActionArea"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/CardActionArea/index.js
 ** module id = 643
 ** module chunks = 0
 **/